import './TableHistoryButton.styles.scss';

import { Button } from 'primereact/button';
import React, { FC } from 'react';

import { Paths } from '../../../Router/Paths';
import { TableButtonProps } from '../TableButton.types';

export const TableHistoryButton: FC<TableButtonProps> = ({
  tableId,
  tableDeleted,
}) => (
  <Button
    className="TableHistoryButton-Component"
    icon="pi pi-history"
    rounded
    disabled={tableDeleted}
    text
    severity="warning"
    aria-label="table history"
    tooltip="History"
    onClick={() => window.open(Paths.HISTORY + `?tableId=${tableId}`)}
  />
);
